import React from "react";
import { Link } from "react-router-dom";
import { C, FONT } from "../../../constants/mq";

// Page header used by every inner page.
//
// It used to stretch a stock photo of children across the top of each page,
// which looked nothing like the landing page and said nothing about the page
// you were on. Now it matches the home hero: bright red band, title, crumbs.
//
// `bannerImg` is still accepted so the existing callers keep working, but it
// is intentionally ignored.

// Bright red with a darker diagonal slice on the right, the way mq.edu.au cuts
// its red panels. Only the banner is red; the page below it is white / sand.
const s = {
  section: {
    background: `linear-gradient(112deg, ${C.bright} 0%, ${C.bright} 66%, #C2001A 66%, #C2001A 100%)`,
    color: "#ffffff",
    padding: "58px 0 54px",
    fontFamily: FONT,
  },
  container: { maxWidth: 1072, margin: "0 auto", padding: "0 24px" },
  heading: {
    fontSize: 40,
    fontWeight: 800,
    letterSpacing: "-0.5px",
    margin: 0,
    lineHeight: 1.18,
    color: "#ffffff",
    maxWidth: 760,
  },
  sub: {
    fontSize: 15.5,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.92)",
    margin: "14px 0 0",
    maxWidth: 620,
  },
  crumbs: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    fontSize: 12.5,
    color: "rgba(255,255,255,0.85)",
    margin: "0 0 14px",
  },
  crumbLink: { color: "#ffffff", textDecoration: "none" },
  sep: { opacity: 0.6 },
};

function CommonBanner({ bannerHeading, subheading, path }) {
  return (
    <section style={s.section}>
      <div style={s.container}>
        {path?.length ? (
          <div style={s.crumbs}>
            <Link to="/" style={s.crumbLink}>
              Home
            </Link>
            {path.map((data, key) => (
              <React.Fragment key={key}>
                <span style={s.sep}>/</span>
                {path.length - 1 === key ? (
                  <span>{data.name}</span>
                ) : (
                  <Link to={data.link} style={s.crumbLink}>
                    {data.name}
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>
        ) : null}

        <h1 style={s.heading}>{bannerHeading}</h1>
        {subheading ? <p style={s.sub}>{subheading}</p> : null}
      </div>
    </section>
  );
}

export default CommonBanner;
